// Styles for OfferPropertiesList go here.
import styled from 'styled-components';
import { toRem } from '@marriott/mi-ui-library';

export const StyledOfferPropertiesList = styled.div`
  margin-top: ${toRem(16)};
  margin-bottom: ${toRem(64)};
`;
